/*
 * @Author: chenxuelai 2251702447@qq.com
 * @Date: 2023-07-05 09:26:23
 * @LastEditors: chenxuelai 2251702447@qq.com
 * @LastEditTime: 2023-09-18 19:45:17
 * @FilePath: /vue_huaqiang/src/api/quote-library.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import request from "@/utils/oms-request";

export const search = (params: any) =>
    request({
        url: `/quote-library/list`,
        method: "get",
        params
    });

export const getModels = (data: {quoteLibraryIds: any }) =>
    request({
        url: `/quote-library/models`,
        method: "post",
        data,
    });

export const getDescription = (data: {quoteLibraryIds: any }) =>
    request({
        url: `/quote-library/description`,
        method: "post",
        data,
    });

    // quote-library/{id}/update-product-number
    // 报价库异常文件上传
export const updateProductNumbeBao = (id,data) =>
    request({
      url: `/quote-library/${id}/update-product-number`,
      method: "post",
      data
    });

    // /quote-library/existed-no-matched-product
    // 是否存在未找到产品的记录
export const existedProduct = (params: any) =>
    request({
        url: `/quote-library/existed-no-matched-product`,
        method: "get",
        params
    });


  // /quote-library/editable-info 查询可编辑的字段
  export const getEditableInfo  = (params: any) =>
  request({
      url: `/quote-library/editable-info`,
      method: "get",
      params
  });
  // /quote-library/upload-record 删除最新的上传记录
  export const deleteUploadRecord  = (params: any) =>
  request({
      url: `/quote-library/latest-upload-record`,
      method: "delete",
      params
  });
  // /quote-library/editable-info/{id} //更改可编辑字段
  export const putEditableInfo  = (id,data: any) =>
  request({
      url: `/quote-library/${id}/editable-info`,
      method: "put",
      data
  });
  // /quote-library/extend-info 更改额外信息
  export const putExtendInfo  = (params,data: any) =>
  request({
      url: `/quote-library/extend-info`,
      method: "put",
      params,
      data
  });
  // /quote-library/statistic 报价库列表表头统计数据
  export const statistic = (params: any) =>
  request({
    url: `/quote-library/statistic`,
    method: "get",
    params
  });
